import $ from 'jquery';
import anime from 'animejs';
import { resizeScroll, refreshScroll } from '../core/ScrollService.js';
import Utils from '../utils/Utils.js';
import { initMobileFilter } from '../features/mobileFilter.js';

export class SearchPage {
    static matches() {
        return document.body.classList.contains('page-template-tpl-search');
    }

    init() {
        let url = new URL(window.location);
    if (document.body.classList.contains('page-template-tpl-search')) {
        const restBtn = document.querySelector('.filterReset');
        const loadAjax = () => {
            const loadMoreBtns = document.querySelectorAll('.loadMoreButton')
            const rows = {
                event: '.hubEventsList__rows',
                post: '.articles_row',
                'white-book': '.articles_row',
                'infographic': '.articles_row',
                ressource: '.hubList__grid',
                'casclient': '.hubList__grid',
                'faq': '.faqs_row',
                'solution': '.solution_row',
                'our-company': '.our-company_row',
                'press': '.press_row',
            }
            url = new URL(window.location);
            let query = url.searchParams.get('search')
            loadMoreBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const currentPage = btn.getAttribute('data-current-page')
                    const group = btn.closest('[data-group]').getAttribute('data-group')
                    const content = btn.closest('[data-collapse-content]')
                    const row = content.querySelector(rows[group])
                    if (!row) {
                        return
                    }
                    btn.classList.add('loadMoreButton--loading');
                    $.ajax({
                        url: ajaxVars.url,
                        type: 'post',
                        data: {
                            action: 'search_ajax',
                            data: {
                                page: parseInt(currentPage) + 1,
                                type: group,
                                query: query
                            }
                        },
                        success: function (result) {
                            btn.classList.remove('loadMoreButton--loading')
                            if (!result.data.has_more) {
                                btn.style.display = 'none'
                            } else {
                                btn.setAttribute('data-current-page', parseInt(currentPage) + 1)
                            }

                            row.innerHTML += result.data.items_html;
                            let contentHeight = content.querySelector('[data-collapse-content-inner]').offsetHeight;
                            anime({
                                targets: content,
                                height: contentHeight,
                                easing: 'easeOutExpo',
                                duration: 600,
                                complete: () => {
                                    refreshScroll(content);
                                }
                            });
                        },
                        error: function (result) { console.log("ERROR", result); },
                    });
                })
            })
        }
        const applyCategoryFilter = (category) => {
            const groups = document.querySelectorAll('[data-group]')
            if (category && category !== 'all') {
                if (restBtn) {
                    restBtn.classList.add('visible')
                    restBtn.classList.remove('hidden')
                }
                groups.forEach(group => {
                    group.style.display = group.getAttribute('data-group') === category ? '' : 'none'
                })
            } else {
                if (restBtn) {
                    restBtn.classList.remove('visible')
                }
                groups.forEach(group => {
                    group.style.display = ''
                })
            }
            resizeScroll()
        }
        const syncSelectFromUrl = () => {
            url = new URL(window.location);
            const category = url.searchParams.get('category')
            const select = document.querySelector('.custom__select[data-filter="category"]')
            if (!select) {
                return category
            }
            if (category && category !== 'all') {
                const choice = select.querySelector(`.custom__select-choice[data-id="${category}"]`)
                if (choice) {
                    const choiceText = choice.querySelector('.choice__text')
                    select.querySelector('.custom__select-btn-text').textContent = choiceText
                        ? choiceText.textContent
                        : category
                    select.querySelector('.custom__select-btn').classList.add('--active')
                    select.querySelectorAll('li').forEach(li => li.classList.remove('--disable'))
                    choice.closest('li')?.classList.add('--disable')
                }
            }
            return category
        }
        const filter = () => {
            applyCategoryFilter(syncSelectFromUrl())
        }
        loadAjax();
        initMobileFilter(filter, false);
        filter();


        // Click btn select
        /////////////////////////////////////////
        $('.custom__select-btn').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.custom__select').find('.custom__select-content').slideToggle()
            $(this).closest('.custom__select').find('.custom__select-btn').toggleClass('--opened')
        })

        // On click choice
        /////////////////////////////////////////
        $('.custom__select-choice').on('click', function (e) {

            e.preventDefault();

            const value = $(this).attr('href').substr(1);

            let url = new URL(window.location);

            if (value === "all") {
                const selectTitle = $(this).closest('.custom__select').data('text')
                $(this).closest('.custom__select').find('.custom__select-btn-text').text(selectTitle)
                $(this).closest('.custom__select-content').find('li').removeClass('--disable')
                $(this).closest('.custom__select').find('.custom__select-btn').removeClass('--active')

                url.searchParams.delete('category');
            } else {
                //change text
                const choiceText = $(this).find('.choice__text').text()
                $(this).closest('.custom__select').find('.custom__select-btn-text').text(choiceText)
                $(this).closest('.custom__select').find('.custom__select-btn').addClass('--active')

                //Hide option
                $(this).closest('.custom__select-content').find('li').removeClass('--disable')
                $(this).closest('li').addClass('--disable')
                url.searchParams.set('category', value)
            }

            //close select
            $(this).closest('.custom__select').find('.custom__select-content').slideToggle()
            $(this).closest('.custom__select').find('.custom__select-btn').toggleClass('--opened')

            Utils.updateUrl(url.href)
            applyCategoryFilter(value)

        })


        restBtn.addEventListener('click', function (e) {

            e.preventDefault();

            let url = new URL(window.location);

            //reset select
            const selects = document.querySelectorAll('.custom__select');

            selects.forEach(select => {

                let term = select.dataset.filter;
                const selectTitle = select.dataset.text;
                const items = select.querySelectorAll('li')

                select.querySelector('.custom__select-btn-text').innerText = selectTitle
                select.querySelector('.custom__select-btn').classList.remove('--active')

                items.forEach(item => {
                    item.classList.remove('--disable')

                    item.querySelector('a').classList.remove('--disabled')
                })

                url.searchParams.delete(term);
            })

            Utils.updateUrl(url.href);

            restBtn.classList.remove('visible')
            document.querySelectorAll('[data-group]').forEach(group => {
                group.style.display = ''
            })
            resizeScroll()

        })
    }
    }
}
